<template>
  <div class="statistics-card" :class="{ 'is-active': isActive }" @click="handleClick">
    <Icon-svg v-if="data.iconType == 'svg'" class="statistics-card__icon" :name="data.url || data.icon" />
    <i v-else :class="data.url || data.icon" class="statistics-card__icon"></i>
    <div class="statistics-card__content">
      <div class="statistics-card__title">
        {{ data.name }}
      </div>
      <div class="statistics-card__value">
        {{ data.value }}
        <span class="statistics-card__unit">{{ data.unit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 统计卡片
 */
export default {
  name: 'StatisticsCard',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          // name: '服务总时长',
          // value: "23:22:12",
          // unit: '',//单位
          // icon: 'icon-clock',
          // iconType: 'icon'//icon 或者 svg
        }
      }
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {};
  },
  computed: {},
  methods: {
    handleClick() {
      this.$emit('click', this.data);
    }
  },
  mounted() { },
};
</script>


<style lang="scss" scoped>
.statistics-card {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  width: 140px;
  height: 56px;
  position: relative;
  background-image: url('./images/data-bg.png');
  background-size: 100% 100%;
  line-height: 1.5;

  &.is-active {
    background-image: url('./images/data-bg-activity.png');
    background-size: 100% 100%;

  }

  &__icon {
    width: 35px;
    height: 35px;
    flex-shrink: 0;
    margin: 0 5px;
  }

  &__content {
    flex: 1;
    text-align: center;
  }

  &__title {
    font-size: 14px;
    color: #fff;
  }

  &__value {

    color: #fff;
    font-weight: bold;
    font-size: 18px;
  }

  &__unit {
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
  }
}
</style>